import { render, staticRenderFns } from "./bannersPromocionales.vue?vue&type=template&id=5b3f1a1f&scoped=true&"
import script from "./bannersPromocionales.vue?vue&type=script&lang=js&"
export * from "./bannersPromocionales.vue?vue&type=script&lang=js&"
import style0 from "./bannersPromocionales.vue?vue&type=style&index=0&id=5b3f1a1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f1a1f",
  null
  
)

export default component.exports